var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Pagination from "../../common/components/Pagination";
import { Loading } from 'element-ui';
import { mapGetters } from "vuex";
import PurInService from "../../api/PurInService";
import CommonService from "../../api/CommonService";
import GlobalVue from "../../globalVue";
import { toDetail } from "../../helper/util";
import { EBillType } from "../../enum/EBillType";
import { UrlHelper } from "../../helper/UrlWrapper";
import { billDefaultDate } from "../../helper/defaultDate";
import _ from 'lodash';
import BillSubTable from "../../components/bill/BillSubTable.vue";
import { EPurInStatus } from "../../enum/EStatus";
import AreaShop from "@/components/AreaShop";
import ArticleList from "../../components/alert/ArticleList.vue";
import DeliverAdd from '../deliver/Add.vue';
import EHandleStatus from '../../enum/EHandleStatus';
import ImageView from "./components/ImageViewer.vue";
import SignView from "./components/SignView.vue";
import OrderSign from "../../components/common/OrderSign.vue";
function getDefaultFormData() {
    var data = {
        status: [
            parseInt(EPurInStatus.Bconfirm),
            parseInt(EPurInStatus.Confirmed)
        ],
        searchType: "1",
        text: "",
        account: "-1",
        s_time: billDefaultDate().Start,
        e_time: billDefaultDate().End,
        dateType: "2",
        diff_order_money: "-1",
        diff_order_amount: "-1",
        diff_order_amount_op: "",
        diff_order_amount_value: ""
    };
    return data;
}
var PurInList = (function (_super) {
    __extends(PurInList, _super);
    function PurInList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = getDefaultFormData();
        _this.statusList = [];
        _this.tableData = [];
        _this.selectedData = [];
        _this.imageOpen = false;
        _this.imageArr = [];
        _this.tableHeight = 0;
        _this.total = 0;
        _this.summary_order_money = 0;
        _this.accounts = [{ name: "全部", id: "-1" }, { name: "已对账", id: "1" }, { name: "未对账", id: "0" }];
        _this.eBillType = EBillType;
        _this.dialogVisible = false;
        _this.exportType = "1";
        _this.isMoreSearch = false;
        _this.dateTypeList = [{ name: "制单日期", id: "1" }, { name: "审核日期", id: "2" }, { name: "确认日期", id: "3" }, { name: "收货日期", id: "4" }];
        _this.ePurInStatus = EPurInStatus;
        _this.signImageOpen = false;
        _this.signImageArr = [];
        _this.type = 'purchasein';
        _this.placeHolder = {
            1: '请输入入库单号',
            2: '请输入货品名称',
            11: '请输入门店名称'
        };
        return _this;
    }
    PurInList.prototype.created = function () {
        var _this = this;
        if (this.global_status$$) {
            if (this.global_status$$.is_diff_order_money) {
                this.formData.status = [parseInt(EPurInStatus.Bconfirm.toString())];
                this.formData.searchType = "12";
                this.formData.diff_order_amount_op = "ne";
                this.formData.diff_order_amount_value = "0";
                this.formData.diff_order_amount = "-1";
            }
            else {
                this.formData.status = [parseInt(this.global_status$$.toString())];
            }
        }
        ;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 120;
            }
        }, 300);
        this.service = PurInService.getInstance();
        this.commonService = CommonService.getInstance();
        GlobalVue.$on('po_sign:ok', this.handleSignSuccess);
    };
    PurInList.prototype.mounted = function () {
        this.areaShopComp = this.$refs.areaShopRef;
        this.getList();
        this.getStatus();
    };
    PurInList.prototype.addTab = function (options) {
        options.opener = this;
        options.showExist = true,
            GlobalVue.$emit('addTab', options);
    };
    PurInList.prototype.createDeliverOrder = function (row) {
        var _this = this;
        var params = {
            order_id: row.order_id,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .createDelivery(params)
            .then(function (res) {
            loadingInstance.close();
            if (res.data.code == 0) {
                var shipData = res.data.data;
                _this.addTab({
                    component: DeliverAdd,
                    title: '修改送货单',
                    name: '修改送货单' + shipData.delivery_order_id,
                    cprops: {
                        handleStatus: EHandleStatus.Edit,
                        order_id: shipData.delivery_order_id,
                    }
                });
                return;
            }
            var instance = _this.$dialog(ArticleList, {
                data: {
                    resData: res.data,
                    modelType: 'deliver'
                },
            }, {
                title: '提示',
                width: 450,
                height: 350,
                closeBtn: false,
            }).instance;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurInList.prototype.viewSignImg = function (row) {
        var _this = this;
        this.service.getSignList({ order_id: row.order_id })
            .then(function (res) {
            var data = res.data;
            if (data.success && data.data.length) {
                if (data.data.length) {
                    var sign_img = data.data;
                    _this.signImageArr = Array.isArray(sign_img) ? sign_img : [];
                    _this.signImageOpen = true;
                }
                else {
                    _this.$message.error("暂无签字图片！");
                }
            }
            else {
                _this.$message.warning('暂无签字图片！');
            }
        }, function (err) { });
    };
    PurInList.prototype.closeSign = function () {
        this.signImageOpen = false;
    };
    PurInList.prototype.getList = function () {
        var _this = this;
        if (this.isMoreSearch) {
            this.isMoreSearch = false;
        }
        var pager = this.$refs.pagination.getPage();
        var params = this.getFormFilter(pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getList(params).then(function (res) {
            var data = res.data.data;
            _this.total = res.data.total;
            _this.summary_order_money = res.data.summary_order_money || 0;
            _.forEach(data, function (item) {
                item.listGoods = [];
                (item.items || []).push({ isBtn: true });
            });
            _this.tableData = data;
            loadingInstance.close();
            if (params.keyword_type == '1') {
                window._czc.push(["_trackEvent", '客户入库搜索类型', '客户入库搜索类型', '按单号搜索']);
            }
            else if (params.keyword_type == '2') {
                window._czc.push(["_trackEvent", '客户入库搜索类型', '客户入库搜索类型', '按货品搜索']);
            }
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    PurInList.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.mulPrint();
                break;
            case 2:
                this.mulExport();
                break;
        }
    };
    PurInList.prototype.pageChange = function (pager) {
        this.getList();
    };
    PurInList.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getList();
    };
    PurInList.prototype.expandChange = function (row, expandedRows) {
        var _this = this;
        if (expandedRows.length == 0) {
            return;
        }
        var params = {
            order_id: row.order_id
        };
        var index = this.tableData.indexOf(row);
        this.service.getListGoods(params).then(function (res) {
            _.forEach(res.data.data, function (item) {
                item.amount = item.order_detail_inamount;
            });
            var listGoods = res.data.data;
            listGoods.push({ isBtn: true });
            GlobalVue.$set(_this.tableData[index], 'listGoods', listGoods);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PurInList.prototype.getStatus = function () {
        var _this = this;
        this.service.getStatus().then(function (res) {
            if (res.data.success) {
                _this.statusList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PurInList.prototype.selectionChange = function (val) {
        this.selectedData = val;
    };
    PurInList.prototype.searchClick = function () {
        this.$refs.pagination.clear();
        this.getList();
    };
    PurInList.prototype.reset = function () {
        this.formData = getDefaultFormData();
        this.areaShopComp.resetData();
    };
    PurInList.prototype.detail = function (row) {
        toDetail(EBillType.PurIn, row.order_id, this);
    };
    PurInList.prototype.LookImage = function (orderId) {
        var _this = this;
        var params = {
            order_id: orderId
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.orderImgById(params).then(function (res) {
            console.log(222222, res.data);
            _this.imageArr = Array.isArray(res.data.data) ? res.data.data : [];
            loadingInstance.close();
            _this.imageOpen = true;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurInList.prototype.closeimg = function (type) {
        this.imageOpen = false;
    };
    PurInList.prototype.toDeliver = function (row) {
        toDetail(EBillType.Deliver, row.delivery_order_id);
    };
    PurInList.prototype.toApply = function (row) {
        toDetail(EBillType.PurOrder, row.purchase_order_order_id);
    };
    PurInList.prototype.mulPrint = function () {
        var orderIds = this.getSelectIds();
        if (!orderIds.length) {
            this.$message.error("请选择单据");
            return;
        }
        ;
        var url = "./static/js/print/print2.html";
        url = UrlHelper.addParam(url, 'type', "purIn");
        url = UrlHelper.addParam(url, 'order_id', orderIds.join(","));
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
        window._czc.push(["_trackEvent", '客户入库打印', '客户入库打印']);
    };
    PurInList.prototype.mulExport = function () {
        this.dialogVisible = true;
    };
    PurInList.prototype.confirmExport = function () {
        var _this = this;
        var orderIds = this.getSelectIds();
        var url = "supplierclientapi/warehouseorder/" + (this.exportType == '1' ? 'export_batch' : 'export_batch_detail');
        var params = {
            order_ids: orderIds.join(","),
            token: this.user.token
        };
        var filter = this.getFormFilter();
        for (var key in filter) {
            filter[key] = (filter[key] === undefined || filter[key] === null) ? '' : filter[key];
            params[key] = filter[key];
        }
        this.commonService.exportCheckPost(url, params)
            .then(function (res) {
            _this.submitExportForm(url, params);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        if (this.exportType == '1') {
            window._czc.push(["_trackEvent", '客户入库单导出', '客户入库单导出', '导出单据']);
        }
        if (this.exportType == '2') {
            window._czc.push(["_trackEvent", '客户入库单导出', '客户入库单导出', '导出明细']);
        }
    };
    PurInList.prototype.submitExportForm = function (url, params) {
        var form = document.createElement('form');
        form.method = 'post';
        form.action = url;
        form.style.display = 'none';
        for (var key in params) {
            if (!params.hasOwnProperty(key)) {
                continue;
            }
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = params[key] === undefined || params[key] === null ? '' : String(params[key]);
            form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    };
    PurInList.prototype.handleSignSuccess = function (alter) {
        if (alter === void 0) { alter = true; }
        if (alter) {
            this.$message.success('签字成功');
            this.searchClick();
        }
        this.$refs.order_sign_dialog.close();
    };
    PurInList.prototype.getFormFilter = function (pager) {
        if (pager === void 0) { pager = {}; }
        var areaShopValue = this.areaShopComp.getFormData();
        var params = __assign({ time_type: this.formData.dateType, s_time: this.formData.s_time && this.formData.s_time.format("yyyy-MM-dd") || "", e_time: this.formData.e_time && this.formData.e_time.format("yyyy-MM-dd") || "", order_sup_status: this.formData.status.join(','), keyword_type: this.formData.searchType, keyword: this.formData.text, is_reconciliation: this.formData.account, sort_field: this.order ? this.order[0] : undefined, sort_type: this.order ? this.order[1] : undefined, area_ids: areaShopValue.area_ids, shop_id: areaShopValue.shop_id, delivery_order_shop_ids: areaShopValue.delivery_order_shop_ids, diff_order_money: this.formData.diff_order_money, diff_order_amount: this.formData.diff_order_amount }, (this.formData.searchType === '12' ? {
            diff_order_amount_op: this.formData.diff_order_amount_op,
            diff_order_amount_value: this.formData.diff_order_amount_value
        } : {}));
        Object.assign(params, pager);
        return params;
    };
    PurInList.prototype.mulConfirm = function () {
        var _this = this;
        if (!this.selectedData.length) {
            this.$message.error("请选择单据");
            return;
        }
        var orderIds = this.getSelectIds();
        this.$confirm("是否要确认", "提示", {}).then(function (res) {
            var params = {
                order_id: orderIds.join(",")
            };
            var loadingInstance = Loading.service({ fullscreen: true });
            var isForceSign = false;
            var shouldSign = false;
            (_this.selectedData || []).forEach(function (item) {
                if (item.purchase_order_confirm_force && item.purchase_order_confirm_force == 1) {
                    isForceSign = true;
                }
                if (item.from_system && item.from_system == 1 && item.purchase_order_confirm_force && item.purchase_order_confirm_force == 1) {
                    shouldSign = true;
                }
            });
            if (shouldSign) {
                var hisSign_1 = "";
                _this.service.latestSignImg(params).then(function (res) {
                    hisSign_1 = res.data.data.latest_sign_url;
                    var miniprogramQrcode = res.data.data.sign_url.url;
                    _this.$refs.order_sign_dialog.show({
                        type: 'wjo',
                        qrcode: miniprogramQrcode,
                        isForceSign: isForceSign,
                        hisSign: hisSign_1,
                        step: hisSign_1 ? 1 : 2,
                    });
                    loadingInstance.close();
                }).catch(function (err) {
                    loadingInstance.close();
                    _this.$message.error(err.message || err.msg);
                });
            }
            else {
                _this.afterSign(false, true, false);
            }
        }, function () { });
    };
    PurInList.prototype.afterSign = function (check, skip_sign, use_latest_sign) {
        var _this = this;
        console.log(check, skip_sign, use_latest_sign);
        if (check) {
            var orderIds = this.getSelectIds();
            this.service.getSignStatus({ order_ids: orderIds.join(',') })
                .then(function (res) {
                var data = res.data;
                if (data.success && data.data.sign_status) {
                    _this.handleSignSuccess();
                }
                else {
                    _this.$message.warning('未获取签字信息，请重新扫码签字');
                }
            }, function (err) { });
        }
        if (skip_sign || use_latest_sign) {
            var orderIds = this.getSelectIds();
            var params = {
                order_id: orderIds.join(","),
                sign_confirm: skip_sign ? 1 : 0,
                use_latest_sign: use_latest_sign ? 1 : 0,
            };
            var loadingInstance_1 = Loading.service({ fullscreen: true });
            this.service.confirm(params).then(function (res) {
                _this.handleSignSuccess(false);
                loadingInstance_1.close();
                var _a = res.data, code = _a.code, data = _a.data;
                if (res.data.code == 69) {
                    var miniprogramQrcode = data && data.msg_data && data.msg_data.url;
                    _this.$refs.order_sign_dialog.show({ type: 'pos', qrcode: miniprogramQrcode });
                }
                else if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getList();
                }
                else {
                    _this.$message.success('操作成功');
                    _this.searchClick();
                }
            }).catch(function (err) {
                _this.handleSignSuccess(false);
                loadingInstance_1.close();
                _this.$message.error(err.message || err.msg);
            });
        }
    };
    PurInList.prototype.getSelectIds = function () {
        var orderIds = this.selectedData.map(function (item) { return item.order_id; });
        return orderIds;
    };
    PurInList.prototype.batchExportOrderImg = function () {
        var _this = this;
        if (!this.selectedData || this.selectedData.length === 0) {
            this.$message.warning('请选择要导出图片的入库单');
            return;
        }
        var hasImgOrders = this.selectedData.filter(function (item) { return item.exists_order_img === 1; });
        console.log('选中入库单:', this.selectedData);
        console.log('有图片的入库单:', hasImgOrders);
        if (hasImgOrders.length === 0) {
            this.$message.warning('选中的入库单没有单据图片');
            return;
        }
        var orderIds = hasImgOrders.map(function (item) { return item.order_id; });
        console.log('导出入库单IDs:', orderIds);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.batchExportOrderImg({ order_ids: orderIds.join(',') })
            .then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                var downloadUrl = res.data.data.download_url;
                if (downloadUrl) {
                    window.open(downloadUrl, '_blank');
                    _this.$message.success('图片打包成功，开始下载');
                }
                else {
                    _this.$message.warning('未找到下载链接');
                }
            }
            else {
                _this.$message.error(res.data.msg || '导出失败');
            }
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg || '导出失败');
        });
    };
    PurInList.prototype.moreSearchComShow = function () {
        this.areaShopComp.getArea();
        this.isMoreSearch = true;
        window._czc.push(["_trackEvent", '客户入库高级查询', '高级查询展开']);
    };
    PurInList.prototype.moreSearchComHide = function () {
        this.isMoreSearch = false;
        window._czc.push(["_trackEvent", '客户入库高级查询', '高级查询收起']);
    };
    PurInList.prototype.renderHeader = function (h, _a) {
        var column = _a.column;
        return h('div', {
            attrs: {
                title: "测试一下"
            }
        }, [
            h('span', column.label)
        ]);
    };
    PurInList = __decorate([
        Component({
            components: {
                'pagination': Pagination,
                BillSubTable: BillSubTable,
                "areaShop": AreaShop,
                'image-view': ImageView,
                'sign-view': SignView,
                'order-sign': OrderSign,
            },
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData',
                "user": "user"
            }))
        })
    ], PurInList);
    return PurInList;
}(Vue));
export default PurInList;
